import { jsxs as r, jsx as l } from "react/jsx-runtime";
const v = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M51.99 6.01h-36c-2.21 0-4 1.79-4 4v43.98c0 2.22 1.8 4.02 4.02 4.02h33.05l-1.07-4H33.05v-44h14.94v44l4-1.07V6.01Zm-20.94 48H16l-.01-.01V10.01h15.06v44Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m36.75 27.402.597 2.23 2.636-2.636v11.836l2-.536V26.937l2.702 2.703.598-2.231-4.27-4.27-4.264 4.263ZM27.988 34.569l-.598-2.231-2.636 2.636V23.138l-2 .536v11.36l-2.702-2.703-.598 2.23 4.27 4.271 4.264-4.263Z"
        }
      )
    ]
  }
);
export {
  v as Lifts
};
